import React from 'react';

const CopyTextIcon = ({ color = '#ffffff', bgcolor = '#000000', ...props }) => (
	<svg width="12" fill={bgcolor} height="17" viewBox="0 0 12 16" {...props}>
		<path
			d="M3.356 7.13v1.136l-2.22-.001v7.23h9.337v-7.23H8.255V7.13h3.355v9.502H0V7.13h3.356zM5.809 0l4.546 4.564-.738.741-3.253-3.264v10.085H5.253V2.041L2 5.305l-.738-.741L5.809 0z"
			fill={color}
		/>
	</svg>
);

export default CopyTextIcon;
